export { default as TicketSolidIcon } from './TicketSolidIcon';
